import React, { createContext, useContext, useMemo, useRef } from 'react';
const ScrollContext = /*#__PURE__*/createContext(undefined);
export const ScrollProvider = _ref => {
  let {
    children
  } = _ref;
  const scrollViewRef = useRef(null);
  const value = useMemo(() => ({
    scrollTo: element => {
      if (element && scrollViewRef.current) {
        const {
          top
        } = element.getBoundingClientRect();
        if (top < 0 || top > window.innerHeight) {
          const headerHeight = getSiteHeaderHeight(scrollViewRef.current);
          const wixAdHeight = getWixAdHeight();
          const newTop = top + window.scrollY - 20 - headerHeight - wixAdHeight;
          window.scrollTo({
            top: newTop,
            behavior: 'smooth'
          });
        }
      }
    }
  }), []);
  return /*#__PURE__*/React.createElement("div", {
    ref: scrollViewRef
  }, /*#__PURE__*/React.createElement(ScrollContext.Provider, {
    value: value
  }, children));
};
export function useScroll() {
  const context = useContext(ScrollContext);
  if (context === undefined) {
    throw new Error('useScroll must be used within a ScrollProvider');
  }
  return context;
}
export function getSiteHeaderHeight(formElement) {
  var _formElement$closest;
  const classicHeader = document.querySelector('#SITE_HEADER');
  const potentialHeader = (_formElement$closest = formElement.closest('main')) == null ? void 0 : _formElement$closest.previousElementSibling;
  const studioHeader = (potentialHeader == null ? void 0 : potentialHeader.tagName) === 'HEADER' ? potentialHeader : undefined;
  const header = classicHeader || studioHeader;
  const headerPosition = header && window.getComputedStyle(header).position;
  return header && (headerPosition === 'sticky' || headerPosition === 'fixed') ? header.getBoundingClientRect().height : 0;
}
export function getWixAdHeight() {
  const ad = document.querySelector('#WIX_ADS');
  return ad && window.getComputedStyle(ad).position === 'fixed' ? ad.getBoundingClientRect().height : 0;
}
//# sourceMappingURL=scroll-provider.js.map